import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1e87df0d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1e87df0d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e87df0d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e87df0d')) {
      api.createRecord('1e87df0d', component.options)
    } else {
      api.reload('1e87df0d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1e87df0d&scoped=true", function () {
      api.rerender('1e87df0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/enterprise/workbench/index.vue"
export default component.exports